import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export default function useConnectionAuthFields({
  selectedTemplate,
  connectionType,
}: {
  selectedTemplate?: number;
  connectionType: string;
}) {
  const auth = useSelector((state: any) => state.paging.connAuthById[connectionType] || {});

  const { templates, items } = auth;

  return useMemo(() => {
    const template =
      selectedTemplate && templates?.length
        ? templates.find((template) => template.id === Number(selectedTemplate))
        : templates?.[0];
    const fields =
      templates && templates?.length > 1 && template
        ? items.filter((item) => template.auth_parameters.includes(item.param_id))
        : items;
    return { fields, templates };
  }, [templates, items, selectedTemplate, connectionType]);
}
